module.exports = __webpack_public_path__ + "static/media/name.db386edc.svg";